// src/components/HubsSection.jsx
import React from "react";

const hubs = [
  {
    label: "Connect Hub",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/hubphotos%2Fconnect.jpg?alt=media&token=77b63c19-eceb-48f5-9dad-851ed256ef0b",
    title: "Build a Global Market Network",
    desc: "Connect with verified professionals, experts, companies, and communities across global financial markets.",
  },
  {
    label: "Trade Hub",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/hubphotos%2Ftrade.jpg?alt=media&token=14d9ebbe-a183-4be5-a25f-d1da6ea82770",
    title: "Trade Across Any Platform",
    desc: "Trade using your preferred broker, charts, and tools together in one unified trading ecosystem.",
  },
  {
    label: "Learn Hub",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/hubphotos%2Flearn.jpg?alt=media&token=54c7ab77-aaf3-44a2-bdb7-beae43386cc5",
    title: "Learn From Top Experts",
    desc: "Access expert-led courses, mentorships, institutional knowledge, and structured learning paths.",
  },
  {
    label: "Earn Hub",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/hubphotos%2Fearn.jpg?alt=media&token=3aa874eb-13df-43fa-80b2-e05481e81112",
    title: "Monetize Your Skills & Products",
    desc: "Sell your expertise, services, indicators, strategies, and digital products to a global audience.",
  },
  {
    label: "Build Hub",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/hubphotos%2Fbuild.jpg?alt=media&token=47c6a9e6-157a-4ca1-8b6b-abbe8adab29e",
    title: "Build Your Business & Career",
    desc: "Create your brand, portfolio, services, and collaborate with professionals and organizations.",
  },
  {
    label: "Launch Hub",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/hubphotos%2Flaunch.jpg?alt=media&token=8a2adde3-f4b9-48a8-84bc-65280dd03e87",
    title: "Test, Launch & Raise Funds",
    desc: "Launch products, validate ideas, raise capital, and scale your business globally.",
  },
];

export default function HubsSection() {
  return (
    <section className="w-full rounded-3xl bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-6">
        {/* ===== SECTION HEADER (OUTSIDE BLOCK) ===== */}
        <div className="mb-12 max-w-3xl">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            One Platform. Multiple <span className="text-blue-600">Hubs</span>
          </h2>
          <p className="mt-1 text-sm text-gray-400 sm:text-base">
            Million2Trillion is designed as a modular professional ecosystem.
            Each hub serves a focused purpose across your market journey.
          </p>
        </div>

        {/* ===== DARK CONTENT CONTAINER (LIKE HERO) ===== */}
        <div className="rounded-3xl bg-[#0B0F19] px-6 py-14 shadow-[0_40px_120px_rgba(0,0,0,0.6)] md:px-12">
          {/* HUB CARDS */}
          <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
            {hubs.map((hub) => (
              <div
                key={hub.label}
                className="group overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] transition-all duration-300 hover:-translate-y-2 hover:border-blue-500/40 hover:shadow-[0_0_40px_rgba(59,130,246,0.25)]"
              >
                {/* IMAGE */}
                <div className="h-40 overflow-hidden">
                  <img
                    src={hub.image}
                    alt={hub.label}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>

                {/* CONTENT */}
                <div className="p-5">
                  <span className="mb-2 inline-block text-xs font-semibold text-blue-400">
                    {hub.label}
                  </span>

                  <h3 className="mb-2 text-lg font-semibold text-white">
                    {hub.title}
                  </h3>

                  <p className="text-sm leading-relaxed text-white/70">
                    {hub.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
